import { useEffect, useState } from 'react';

import { classNameList } from 'utils/property';
import { useGlobalLoading } from 'hooks/useGlobalLoading';
import styles from './GlobalLoader.module.scss';

export const GlobalLoader = (): JSX.Element => {
  const { loading } = useGlobalLoading();
  const [visible, setVisible] = useState<boolean>(true);
  const items = ['first', 'second', 'third'];

  useEffect(() => {
    if (!loading) {
      setTimeout(() => {
        setVisible(false);
      }, 800);
    }
  }, [loading]);

  return (
    <div
      className={classNameList(styles.globalLoader, !visible && styles.globalLoaderHidden)}
      tabIndex={-1}
      aria-hidden={!visible}>
      <div className={styles.globalLoaderHeader}></div>
      <div className={styles.globalLoaderContent}>
        <div className={styles.globalLoaderContentTitle} />
        <div className={styles.globalLoaderContentSubtitle} />
        <div className={styles.globalLoaderContentText} />
        <div className={styles.globalLoaderContentItems}>
          {items.map((name: string) => (
            <div key={name} className={styles.globalLoaderContentItemsItem}>
              <div className={styles.globalLoaderContentItemsItemTitle}>
                <div></div>
                <div></div>
              </div>
              <div className={styles.globalLoaderContentItemsItemText}>
                <div></div>
                <div></div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className={styles.globalLoaderFooter}></div>
    </div>
  );
};
